import { useRef } from 'react';

import { useIntersectionObserver } from '@/modules/pagination/useIntersectionObserver';
import {
  useShortlistActions,
  useShortlistCtaRevealed,
} from '@/modules/public-shortlist/store';

export function useShortlistCtaReveal(shortlistKey: string) {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const ctaRevealed = useShortlistCtaRevealed(shortlistKey);
  const { setCtaRevealed } = useShortlistActions();

  useIntersectionObserver({
    target: sentinelRef,
    onIntersect: () => setCtaRevealed(shortlistKey, true),
    threshold: 0.35,
    enabled: !ctaRevealed,
  });

  return { sentinelRef, ctaRevealed };
}
